module.exports = __webpack_public_path__ + "img/bg-new-certif.be4c3152.png";